import type { PokemonV2 } from '../../types/pokemon';
import { POKEMON_TYPE_FLYING, POKEMON_TYPE_STERA } from '../../types/type';
import {
  OFFENCE_ITEM_ID_BALLOON,
  DEFENCE_ITEM_ID_BALLOON,
} from '../../types/item';
import { isHuyuu } from '../ability';
import { getArceusEffectiveType } from '../../pokemon/PlateUtils';

/**
 * きもったま／しんがん等でゴーストに攻撃できるかを判定する。
 */
export function canScrappy(pokemon: PokemonV2): boolean {
  if (!pokemon.selected_ability) {
    return false;
  }
  const abilityName = pokemon.selected_ability.name_ja;
  const isScrappy = abilityName === 'きもったま' || abilityName === 'しんがん';
  const moveType = pokemon.selected_move?.type;
  if (!isScrappy || moveType == null) {
    return false;
  }
  return moveType === 1 || moveType === 2;
}

/**
 * ポケモンが地面に接していない状態かを判定する。
 */
export function isNotGrounded(
  pokemon: PokemonV2,
  isOffence: boolean,
): boolean {
  const baseEffectiveTypes = getArceusEffectiveType(pokemon as any);
  const effectiveTypes =
    pokemon.terasu_type && pokemon.terasu_type > 0 && pokemon.terasu_type !== POKEMON_TYPE_STERA
      ? [pokemon.terasu_type]
      : baseEffectiveTypes;
  if (effectiveTypes.includes(POKEMON_TYPE_FLYING)) return true;

  if (isOffence) {
    if (pokemon.selected_item_id === OFFENCE_ITEM_ID_BALLOON) {
      return true;
    }
  } else if (pokemon.selected_item_id === DEFENCE_ITEM_ID_BALLOON) {
    return true;
  }

  if (isHuyuu(pokemon)) {
    return true;
  }

  return false;
}
